import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import CONFIG from '../config';
import Logo from '../img/logo.svg';
import NavItem from './NavLink';
import Button from 'react-bootstrap/Button';
import Collapse from 'react-bootstrap/Collapse';

import i18n from '../utils/i18n';

const Navigation = () => {
    const [open, setOpen] = useState(false);

    return (
        <nav className="navbar fixed-top navbar-expand-lg navbar-dark">
            <NavLink className="navbar-brand" to={CONFIG.ROUTES.HOME} exact>
                <span>Wik</span><img src={Logo} alt="Logo" />
            </NavLink>
            <Button
                className="navbar-toggler"
                onClick={() => setOpen(!open)}
                aria-controls="navbar-cnt"
                aria-label="Toggle navigation"
                aria-expanded={open}
            >
                <span className="navbar-toggler-icon"> </span>
            </Button>
            <Collapse in={open}>
                {/*<div className="collapse navbar-collapse" id="navbar-cnt">*/}
                <div className="navbar-collapse" id="navbar-cnt">
                    <ul className="navbar-nav ml-auto mt-3 mt-lg-0">
                        <NavItem to={CONFIG.ROUTES.HOME} exact>{i18n.NAV_HOME}</NavItem>
                        <NavItem to={CONFIG.ROUTES.ABOUT}>{i18n.NAV_ABOUT}</NavItem>
                        <NavItem to={CONFIG.ROUTES.NEWS}>{i18n.NAV_NEWS}</NavItem>
                        <NavItem to={CONFIG.ROUTES.PROJECTS}>{i18n.NAV_PROJECTS}</NavItem>
                        <NavItem to={CONFIG.ROUTES.CONTACT}>{i18n.NAV_CONTACT}</NavItem>
                    </ul>
                </div>
            </Collapse>
        </nav>
    );
};

export default Navigation;
